import { useContext } from 'react';
import { StateContext } from '../GlobalStateStore';
import { InspireOptions } from '../Types';

const useInspireOptions = (): InspireOptions => {
  return useContext(StateContext).state.inspireOptions.data;
};

export default useInspireOptions;
